import { NotFoundPage } from '@lbcamden/lib-react';
import { FunctionComponent } from 'react';

import { useTinybaseStore } from '~/client/store/tinybase/tinybaseStore';

import { LoadInPage } from '../../common/LoadInPage';

/**
 * Useful for when the app is opened on an URL for a entity that needs to synced first.
 * Otherwise the user would be presented with a not found page with no indication that a sync is occurring
 * */
export const LoadInNotFoundPage: FunctionComponent = () => {
  const { isSyncing } = useTinybaseStore((state) => state.propertyDataSyncState);

  return (
    <LoadInPage loading={isSyncing}>
      <NotFoundPage />
    </LoadInPage>
  );
};
